import './AcVideoPlayer.scss';
import ReactPlayer from 'react-player'

/**
 * @author Shishir
 * @param videoUrl - this is the mp4/webm/ogg video url
 * @param videoThumbnail - this is the thumbnail image for the video
 * @returns video player constructed using video js library
 */
export default function AcVideoPlayer({videoUrl,videoThumbnail}) {
    return (
        <div className='ac-video-player__container'>
            <ReactPlayer className='ac-video-player__video' controls url={videoUrl} width='500px' height='318.05px' />
        </div>
    )
}
